import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
    userMaintainerWrapper: {
        fontFamily: `'Manrope', sans-serif`,
    },
    userMaintainerHeader: {
        background: '#F8FAFC',
        padding: 15,
        height: 90,
        display: 'flex',
        alignItems: 'center',
        boxShadow: 'inset 0px -1px 0px #F0F0F0'
    },
    userMaintainerHeaderBreadcrumb: {
        '& ol': {
            alignItems: 'flex-end'
        }
    },
    userMaintainerHeaderBreadcrumbTitle: {
        fontSize: 18,
        lineHeight: '24px',
        fontWeight: 'bold',
        color: '#38cfc4',
        fontFamily: `'Manrope', sans-serif`,
        '&.active': {
            color: '#465869'
        },
        '&.linkToPeopleTab': {
            cursor: 'pointer'
        }
    },
    userMaintainerBody: {
        padding: 22
    },
    userMaintainerBodySectionTitle: {
        marginBottom: 28,
        fontSize: 18,
        lineHeight: '18px',
        fontWeight: 'bold',
        color: '#465869'
    },
    userMaintainerBodySection: {
        marginBottom: 28
    },
    userMaintainerTimezoneMessage: {
        color: '#465869',
        fontSize: 12,
        lineHeight: '24px'
    }
}))

export default styles